import { useEffect, useState } from 'preact/hooks';
import { useLocation } from 'wouter-preact';
import { Button } from '../ui/Button.jsx';
import { Sheet } from '../ui/Sheet.jsx';
import { useDb, useSession, useSync } from '../contexts.jsx';
import { progressForStation } from '../store/selectors.js';

export function Home() {
  const { db } = useDb();
  const session = useSession();
  const sync = useSync();
  const [, navigate] = useLocation();
  const [prog, setProg] = useState(null);
  useEffect(() => {
    progressForStation(db, session.station).then(setProg);
  }, [db, session.station, sync.lastSyncedAt]);
  return (
    <>
      <Sheet>
        <Button variant="primary" block onClick={() => navigate('/scan')}>
          Scan QR
        </Button>
        <div style={{ height: 8 }} />
        <Button block onClick={() => navigate('/search')}>
          Search
        </Button>
      </Sheet>
      {prog && (
        <Sheet>
          <div style={{ fontSize: 13, color: 'var(--muted)' }}>
            {session.station || 'All stations'}
          </div>
          <div style={{ fontSize: 24, fontWeight: 600 }}>
            {prog.handed} / {prog.families}
          </div>
          <div style={{ color: 'var(--muted)' }}>{prog.remaining} remaining</div>
        </Sheet>
      )}
    </>
  );
}
